import { Mark } from '@tiptap/core'

const FontWeight = Mark.create({
  name: 'fontweight',

  addOptions () {
    return {
      fontWeight: ['400']
    }
  },

  addAttributes () {
    return {
      fontWeight: {
        default: '400',
        parseHTML: element => {
          return element.style.fontWeight || element.getAttribute('data-font-weight') || '400'
        },
        renderHTML: attrs => {
          return {
            style: `font-weight:${attrs.fontWeight}`
          }
        }
      }
    }
  },

  parseHTML () {
    return [
      {
        tag: 'spane'
      }
    ]
  },

  renderHTML ({ HTMLAttributes }) {
    return ['spane', HTMLAttributes, 0]
  },

  addCommands () {
    return {
      fontweight: attrs => ({ commands }) => {
        const value = attrs && attrs.fontWeight ? attrs.fontWeight : null

        if (!value) {
          return commands.unsetMark(this.name)
        }

        return commands.setMark(this.name, { fontWeight: value })
      }
    }
  }
})

export default FontWeight
